import { useDispatch } from "react-redux";

import { Switch } from "antd";
import { widgetHoverAtom } from "atoms/interaction";
import classnames from "classnames";
import { EvaChart } from "constants/charts.enums";
import { useChartsContext } from "contexts";
import { useAtomValue } from "jotai";
import { updateChartByPath } from "store/features";
import styled from "styled-components/macro";

import { useChartEntities } from "hooks/charts";

import { visibilityToggleStyles } from "../../shared/SharedStyles";

interface WellCountToggleT {
  type: string;
}

const WellCountToggle = ({ type = "Well" }: WellCountToggleT) => {
  const dispatch = useDispatch();
  const { id } = useChartsContext();
  const { chartType, screenshot, showWellCount, dataTable } = useChartEntities(id);

  const widgetHoverMap = useAtomValue(widgetHoverAtom);
  const isHover = widgetHoverMap?.[id] ?? false;

  // derived state
  const isTotalRateDate =
    chartType === EvaChart.TotalRateDate || chartType == EvaChart.TotalRateDateMidstream;
  const showWellCountToggle = isTotalRateDate && !screenshot.active && !dataTable.active;

  const toggleLabel = type === "Well" ? "Well Count" : "Facility Count";

  const handleToggle = (value) => {
    dispatch(
      updateChartByPath({
        id,
        path: "features.showWellCount.active",
        value: value
      })
    );
  };

  // derived classes
  const wrapperClasses = classnames({
    visible: showWellCountToggle && isHover
  });

  return (
    <Wrapper
      className={wrapperClasses}
      data-testid="wellCountToggle"
      id="wellCountContainerId">
      <span>{toggleLabel}</span>
      <Switch size="small" checked={showWellCount} onChange={(v) => handleToggle(v)} />
    </Wrapper>
  );
};

export default WellCountToggle;

const Wrapper = styled.div`
  ${visibilityToggleStyles};
  position: absolute;
  bottom: 4px;
  right: 107px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  z-index: 2;

  &.stackDown {
    z-index: 0;
  }
`;
